import React, { MouseEventHandler } from 'react';
import { Div, DivProps, Label, Span } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';

export interface SustainabilityProps extends DivProps {
  iconName?: string;
  onDivElementClick?: MouseEventHandler;
  onLabelClick?: MouseEventHandler;
  score: string;
  text?: string;
  variant?: string;
  tabToOpen?: number;
}

export function getDisplayedScore(score: string) {
  return score &&
    score !== 'undefined' &&
    score !== '0,0' &&
    score !== '0.0' &&
    score !== '0'
    ? score.replace('.', ',')
    : '-,-';
}

export const Sustainability: React.FC<SustainabilityProps> = ({
  iconName = 'leaf',
  onDivElementClick,
  onLabelClick,
  score,
  text,
  variant = 'sustainability',
  ...restProps
}: SustainabilityProps) => {
  let scoreColor = 'second.0';
  let displayScore = score;

  if (!score || score === '0.0') {
    displayScore = '-,-';
  }

  if (score) {
    scoreColor = 'main.2';
  }

  return (
    <Div
      data-testid="sustainability-div"
      borderRadius={1}
      display="inline-flex"
      variant={variant}
      {...restProps}
      onClick={onDivElementClick}
    >
      <Icon my="auto" name={iconName} variant="success" />
      <Div display="flex" flexDirection="column">
        <Span
          color={scoreColor}
          fontFamily="heading"
          fontSize={5}
          fontWeight={1}
          lineHeight={2}
        >
          {getDisplayedScore(displayScore)}
        </Span>
        {text && (
          <Label
            data-testid="sustainability-label"
            onClick={onLabelClick}
            style={{
              cursor: onLabelClick !== undefined ? 'pointer' : '',
            }}
            variant="sustainability"
          >
            {text}
          </Label>
        )}
      </Div>
    </Div>
  );
};
